import { Component } from "react";

export interface Props {
    firstName: string;
    lastName: string;
    cityCountryName: string;
    phoneNumber: string;
    email: string;
    Iam: Record<string, string>;
    jobs: string;
    shortIntro: Record<string, string>;
    lang: string;
};

// Type pour l'animation typewrite
class TxtType {
    toRotate: string[];
    el: HTMLElement;
    loopNum: number;
    period: number;
    txt: string;
    isDeleting: boolean;

    constructor(el: HTMLElement, toRotate: string[], period: number) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period.toString(), 10) || 2000;
        this.txt = '';
        this.isDeleting = false;
        this.tick();
    }

    tick() {
        const i = this.loopNum % this.toRotate.length;
        const fullTxt = this.toRotate[i];

        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

        let delta = 200 - Math.random() * 100;

        if (this.isDeleting) {
            delta /= 2;
        }

        if (!this.isDeleting && this.txt === fullTxt) {
            delta = this.period;
            this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
            this.isDeleting = false;
            this.loopNum++;
            delta = 500;
        }

        setTimeout(() => {
            this.tick();
        }, delta);
    }
}

export default class About extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        // Initialiser l'animation typewrite après le rendu du composant
        const elements = document.getElementsByClassName('typewrite');
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as HTMLElement;
            const toRotate = element.getAttribute('data-type');
            const period = element.getAttribute('data-period');
            if (toRotate) {
                new TxtType(element, JSON.parse(toRotate), parseInt(period || '2000'));
            }
        }
    }

    render() {
        return (
            <div className="my-auto about-section">
                <h1 className="mb-0 name-title">
                    {this.props.firstName}
                    <span className="text-primary"> {this.props.lastName}</span>
                </h1>
                <div className="subheading mb-5">
                    <i className="fas fa-map-marker-alt" style={{marginRight: '8px', opacity: 0.7}}></i>
                    {this.props.cityCountryName}
                    <span style={{margin: '0 12px', opacity: 0.4}}>·</span>
                    <a href={"mailto:" + this.props.email} className="email-link">
                        <i className="fas fa-envelope" style={{marginRight: '6px'}}></i>
                        {this.props.email}
                    </a>
                </div>

                <p className="lead intro-text">
                    {this.props.Iam[this.props.lang]+" "}
                    <a className="text-primary typewrite" data-period="2000" data-type={this.props.jobs}>
                        <span className="wrap"></span>
                    </a><span className="blink">|</span>
                </p>
                <p className="lead mb-5 description-text">{this.props.shortIntro[this.props.lang]}</p>

            </div>
        );
    }
}
